import React from "react";
import Spinner from "react-bootstrap/Spinner";
import Modal from "react-bootstrap/Modal";
import Avatar from "../../../../../assets/images/avatarr.png";
import Phone from "../../../../../assets/images/phone.png";
import { Form, Input } from "antd";

const EvacuationCodeModal = ({
  showEvacuation1,
  handleCloseEvacuation1,
  modalInfo,
  evacCode,
  setEvacCode,
  getEvacuationByCode,
  loading2,
  handleShowEvacuation2
}) => {
  //   console.log(modalInfo);
  return (
    <div>
      <Modal
        show={showEvacuation1}
        onHide={() => {
          handleCloseEvacuation1();
        }}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <div class="modal-header">
          <h5 class="modal-title">Enter Evacuation Code</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={() => {
              handleCloseEvacuation1();
            }}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <Modal.Body>
          <div className="mx-2">
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex mt-4">
                <div style={{ width: "35px" }}>
                  <img src={Avatar} alt="avatar" style={{ width: "100%" }} />
                </div>
                <div>
                  <p
                    className="mb-0 ml-2"
                    style={{
                      fontSize: "18px",
                      fontWeight: "600",
                      color: "#000",
                    }}
                  >
                    {modalInfo?.center?.name}
                  </p>
                  <p
                    className="mb-0 ml-2"
                    style={{ fontSize: "14px", color: "#898989" }}
                  >
                    {modalInfo?.center?.address}
                  </p>
                </div>
              </div>

              <div className="d-flex align-items-center mt-4">
                <img src={Phone} alt="phone" />
                <p
                  className="mb-0 ml-3"
                  style={{ fontSize: "14px", color: "#898989" }}
                >
                  {modalInfo?.center?.phone}
                </p>
              </div>
            </div>

            <div className="d-flex justify-content-between align-items-center">
              <div style={{ width: "60%" }}>
                <div className="mb-3 mt-4">
                  <label className="mb-1 form-label">Evacuation Code</label>
                  <input
                    type="text"
                    className="form-control form-control-lg inputStyle"
                    placeholder="Enter evacuation code"
                    value={evacCode}
                    onChange={(e) => setEvacCode(e.target.value)}
                  />
                </div>
                <div className="mt-4 mb-5  w-75">
                  <button
                    type="button"
                    className="btn loginBtn btn-sm btn-block"
                    onClick={() => {
                    //   handleCloseEvacuation1();
                    //   handleShowEvacuation2();
                      getEvacuationByCode(evacCode);
                    }}
                  >
                    {loading2 ? (
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      "Continue"
                    )}
                  </button>
                </div>
              </div>
              <div>
                <div className="mt-4">
                  <p
                    className="mb-0 mr-2"
                    style={{
                      fontSize: "13px",
                      color: "#000000",
                      fontWeight: "600",
                    }}
                  >
                    3rd Party Driver Details
                  </p>
                </div>
                <div className="d-flex align-items-center mt-2">
                  <img src={Avatar} alt="avatar" />
                  <p
                    className="mb-0 ml-2"
                    style={{ fontSize: "14px", color: "#000" }}
                  >
                    {modalInfo?.driver_name}
                  </p>
                </div>
                <div className="d-flex align-items-center mt-4">
                  <img src={Phone} alt="phone" />
                  <p
                    className="mb-0 ml-2"
                    style={{ fontSize: "14px", color: "#898989" }}
                  >
                    {modalInfo?.driver_phone}
                  </p>
                </div>
                <div className="mt-4">
                  <p
                    className="mb-0 mr-2"
                    style={{ fontSize: "13px", color: "#000" }}
                  >
                    Vehicle No:
                  </p>
                  <p
                    className="mb-0 mr-2"
                    style={{
                      fontSize: "13px",
                      color: "#000000",
                      fontWeight: "400",
                    }}
                  >
                    {modalInfo?.vehicle_plate_no}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default EvacuationCodeModal;
